import { MeasurementUtility, WeightUtility } from '@inter-ikea-kompis/utilities/lib';
export const metricLengthToFormattedImperial = (cm, kompisTranslations) => {
    const mm = cmTOmm(cm);
    return MeasurementUtility.metricToImperial(kompisTranslations, mm, false, true);
};
export const metricWeightToLb = (kilo) => {
    return WeightUtility.metricToImperial(kilo).lb;
};
export const cmTOmm = (value) => value * 10;
export const mmTOcm = (value) => value / 10;
//# sourceMappingURL=measurement.js.map